module.exports = __webpack_public_path__ + "media/images/icons/zoom-829dc6c667a42e7af0b4cd184b08ccf0.gif";